import useBreakpoints from '@utils/useBreakpoints';

export default function useHeaderMenuHeight() {
  const { smDown, xsDown } = useBreakpoints();
  return xsDown ? 75 : smDown ? 100 : 150;
}
